import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token as backup + workspace id
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("bp_token");
  if (token && !cfg.headers.Authorization) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  const ws = localStorage.getItem("bp_workspace");
  if (ws) cfg.headers["X-Workspace-Id"] = ws;
  return cfg;
});

export function formatDetail(detail) {
  if (detail == null) return "Ein Fehler ist aufgetreten.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return String(detail.msg);
  return String(detail);
}

export function fmtEUR(v, currency = "EUR") {
  if (v === null || v === undefined || isNaN(v)) return "—";
  try {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(Number(v));
  } catch {
    return `${Number(v).toFixed(2)} ${currency}`;
  }
}

export function fmtDate(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return String(v);
  }
}

export function fmtDateTime(v) {
  if (!v) return "—";
  try {
    return new Date(v).toLocaleString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return String(v);
  }
}

export function fmtBytes(n) {
  if (!n && n !== 0) return "—";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
